// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"52f169bb5720725f","888":"595c8789a9028604"}[chunkId] + ".css";
};